(() => {
  const SOURCE_GALLERY = 'Gallery design';
  const SOURCE_TYPE = 'Type the breed';
  const SOURCE_PHOTO = 'Upload a photo';
  const ERROR_MESSAGE = 'Choose how we make the art, then finish that step.';

  function sourceSelect() {
    return document.querySelector('[data-lylaloo-framed-art-source]');
  }

  function breedInput() {
    return document.querySelector('[data-lylaloo-breed-gallery-input]');
  }

  function typedInput() {
    return document.querySelector('[data-lylaloo-typed-breed]');
  }

  function photoInput() {
    return document.querySelector('[data-lylaloo-custom-photo]');
  }

  function rootOf(el) {
    return el && (el.closest('product-custom-property-component') || el.closest('.shopify-block') || el.parentElement);
  }

  function gallerySections() {
    return document.querySelectorAll('[data-breed-gallery], #stained-glass-design-gallery');
  }

  function errorEl(select) {
    const root = rootOf(select);
    return (root && root.querySelector('[data-lylaloo-framed-art-error]')) || null;
  }

  function setRequired(el, on) {
    if (!el) return;
    if (on) {
      el.required = true;
      el.setAttribute('required', '');
      el.setAttribute('aria-required', 'true');
    } else {
      el.required = false;
      el.removeAttribute('required');
      el.setAttribute('aria-required', 'false');
    }
  }

  function setPathVisible(el, visible) {
    const root = rootOf(el);
    if (root) {
      root.hidden = !visible;
      root.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }
    if (el) el.disabled = !visible;
  }

  function clearField(el) {
    if (!el) return;
    el.value = '';
    if (typeof el.setCustomValidity === 'function') el.setCustomValidity('');
    el.classList.remove('is-invalid');
  }

  function setHtmlMode(value) {
    const root = document.documentElement;
    root.classList.add('lylaloo-framed-art');
    root.classList.toggle('lylaloo-framed-art--gallery', value === SOURCE_GALLERY);
    root.classList.toggle('lylaloo-framed-art--typed', value === SOURCE_TYPE);
    root.classList.toggle('lylaloo-framed-art--photo', value === SOURCE_PHOTO);
  }

  function applySource(select) {
    const value = select ? select.value : '';
    const breed = breedInput();
    const typed = typedInput();
    const photo = photoInput();
    const showGallery = value === SOURCE_GALLERY;
    const showTyped = value === SOURCE_TYPE;
    const showPhoto = value === SOURCE_PHOTO;

    setHtmlMode(value);
    setPathVisible(breed, showGallery);
    setPathVisible(typed, showTyped);
    setPathVisible(photo, showPhoto);

    gallerySections().forEach((section) => {
      section.hidden = !showGallery;
      section.setAttribute('aria-hidden', showGallery ? 'false' : 'true');
      if (showGallery) section.style.removeProperty('display');
      else section.style.display = 'none';
    });

    setRequired(select, true);
    setRequired(breed, showGallery);
    setRequired(typed, showTyped);
    setRequired(photo, showPhoto);

    if (!showGallery) {
      clearField(breed);
      const wrap = breed && (breed.closest('.__input-wrapper--breed-gallery') || breed.parentElement);
      const breedError = wrap && wrap.querySelector('[data-lylaloo-breed-required-error]');
      if (breedError) breedError.hidden = true;
    }
    if (!showTyped) clearField(typed);
    if (!showPhoto) clearField(photo);

    const error = errorEl(select);
    if (error) error.hidden = true;
    if (select) select.setCustomValidity('');
  }

  function pathComplete(select) {
    const value = select ? select.value : '';
    if (!value) return false;
    // xmas tumblers only: the gallery is one fixed design, so no breed field is required (flag set in blocks/product-custom-property.liquid)
    if (value === SOURCE_GALLERY && select.hasAttribute('data-lylaloo-gallery-fixed')) return true;
    if (value === SOURCE_GALLERY) return Boolean(String(breedInput() && breedInput().value || '').trim());
    if (value === SOURCE_TYPE) return Boolean(String(typedInput() && typedInput().value || '').trim());
    if (value === SOURCE_PHOTO) {
      const photo = photoInput();
      return Boolean(photo && photo.files && photo.files.length > 0);
    }
    return false;
  }

  function showError(select) {
    const value = select ? select.value : '';
    const message = value === SOURCE_PHOTO ? 'Attach a photo to continue.' : ERROR_MESSAGE;
    const error = errorEl(select);
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
    const photo = photoInput();
    if (select) select.setCustomValidity(value === SOURCE_PHOTO ? '' : message);
    if (photo && value === SOURCE_PHOTO) {
      setRequired(photo, true);
      photo.setCustomValidity(message);
      photo.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { photo.reportValidity(); } catch (err) { /* ignore */ }
      photo.focus({ preventScroll: true });
      return;
    }
    if (!select) return;
    select.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { select.reportValidity(); } catch (err) { /* ignore */ }
    select.focus({ preventScroll: true });
  }

  function bind() {
    const select = sourceSelect();
    if (!select || select.dataset.lylalooFramedArtBound === '1') return;
    select.dataset.lylalooFramedArtBound = '1';
    applySource(select);
    select.addEventListener('change', () => applySource(select));

    const formId = select.getAttribute('form');
    const form = (formId && document.getElementById(formId)) || select.closest('form');
    const blockIfIncomplete = (event) => {
      if (pathComplete(select)) {
        const error = errorEl(select);
        if (error) error.hidden = true;
        select.setCustomValidity('');
        const photo = photoInput();
        if (photo) photo.setCustomValidity('');
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(select);
    };

    if (form) {
      form.addEventListener('submit', blockIfIncomplete, true);
      form.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (!target.closest('add-to-cart-component, [name="add"], button[type="submit"]')) return;
        blockIfIncomplete(event);
      }, true);
    }
  }

  function start() {
    if (!sourceSelect()) return;
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
